import React from "react";
import { Sparkles } from "lucide-react";
import landing from "@/content/landing";
import { Section } from "./HeroSection";

/**
 * LINA — Stage 1: rein visueller Teaser.
 * Kein Chat, kein LLM, kein API-Call. Nur Text.
 */
export default function LinaTeaser() {
  const t = landing.lina;
  return (
    <Section id="lina" className="bg-gradient-to-b from-ag-paper via-ag-paper to-white relative overflow-hidden" data-testid="landing-lina">
      <div className="ag-gold-ambient" style={{ width: 420, height: 420, top: -180, left: "50%", transform: "translateX(-50%)", opacity: 0.25 }} aria-hidden="true" />
      <div className="relative mx-auto max-w-2xl text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-amber-300 to-amber-600 text-white shadow-xl ring-8 ring-amber-100/60">
          <Sparkles className="h-8 w-8" strokeWidth={1.4} aria-hidden="true" />
        </div>
        <h2 className="mt-7 font-serif text-3xl leading-tight text-ag-ink sm:text-4xl lg:text-5xl">
          {t.headline}
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-700 sm:text-[17px]">
          {t.text}
        </p>
        <div className="mt-7 inline-flex items-center gap-2 rounded-full border border-amber-300/70 bg-amber-50 px-4 py-2 text-xs font-medium uppercase tracking-[0.22em] text-amber-800">
          <span className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse" aria-hidden="true" />
          {t.status}
        </div>
        <p className="mt-7 font-serif text-lg italic text-slate-500">{t.note}</p>
      </div>
    </Section>
  );
}
